import { ReactElement } from 'react';
import { MEDIA_QUERIES, useMediaQuery } from '@student-coin/coinpaper-components';
import { Container, Header } from './SearchHeader.styles';

export interface SearchHeaderProps {
  title: string;
}

export const SearchHeader = ({ title }: SearchHeaderProps): ReactElement => {
  const isTabletWide = useMediaQuery(MEDIA_QUERIES.tablet);

  if (!isTabletWide) {
    return null;
  }

  return (
    <Container>
      <Header>{title} /</Header>
    </Container>
  );
};
